export { default as MicOffIcon } from '~icons/tabler/microphone-off';
